var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "client-title--xxxl"
  }, [_vm._v("위드캔 스토리")])]), !_vm.$route.params._board && _vm.$route.query.mode !== 'input' ? [_c('v-tabs', {
    staticClass: "board-tabs",
    attrs: {
      "grow": "",
      "hide-slider": "",
      "show-arrows": false
    },
    model: {
      value: _vm.tab,
      callback: function ($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/board/story"
    }
  }, [_vm._v("전체")]), _c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/board/story/newsletter"
    }
  }, [_vm._v("재단 소식")]), _c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/board/story/supporter"
    }
  }, [_vm._v("후원자 소식")]), _c('v-tab', {
    attrs: {
      "exact": "",
      "to": "/board/story/news"
    }
  }, [_vm._v("사업기관 소식")])], 1), _c('board-list', {
    attrs: {
      "code": [`newsletter`, `supporter`, `news`],
      "limit": 6
    }
  })] : _vm.$route.query.mode === 'input' ? _c('board-write') : _c('board-view')], 2)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }